"use strict";

import ContentService from "../Services/Content";

export default class ModalHelper {
	/**
	 * Show information page
	 * @param linkId
	 * @param hasCheckout
	 */
	static showInformationPage(linkId = '', hasCheckout = false) {
		const id = "sparxpresInformationPageModal";
		let infoModal = document.getElementById(id);
		if (!infoModal) {
			infoModal = this._buildRootElement(id);

			const params = {
				"linkId": linkId,
				"sb": hasCheckout ? 0 : 1
			};

			new ContentService(linkId).getInformationContent(params).then(content => {
				const modalElem = this._buildModalContentElement(id, content);
				infoModal.appendChild(modalElem);
				document.body.appendChild(infoModal);
			});
		} else {
			// show modal
			infoModal.classList.remove("sparxpres-d-none");
		}
	}

	/**
	 * Show XpresPay page
	 * @param linkId
	 */
	static showXpresPayPage(linkId = '') {
		const id = "xpresPayInformationPageModal";
		let xpresPayModal = document.getElementById(id);
		if (!xpresPayModal) {
			xpresPayModal = this._buildRootElement(id);

			const params = {
				"linkId": linkId
			};

			new ContentService(linkId).getXpresPayInformationContent(params).then(content => {
				const modalElem = this._buildModalContentElement(id, content);
				xpresPayModal.appendChild(modalElem);
				document.body.appendChild(xpresPayModal);
			});
		} else {
			// show modal
			xpresPayModal.classList.remove("sparxpres-d-none");
		}
	}

	/**
	 * Show loan application page
	 * @param applicationSrc
	 */
	static showLoanApplicationPage(applicationSrc = '') {
		const id = "sparxpresLoanApplicationPageModal";
		let applicationModal = document.getElementById(id);
		if (!applicationModal) {
			applicationModal = this._buildRootElement(id);

			const content = {
				"html": "<iframe class=\"sparxpres-dynamic-iframe\" src=\"" + applicationSrc + "\"></iframe>",
				"style": "",
				"script": ""
			};

			const modalElem = this._buildModalContentElement(id, content);
			applicationModal.appendChild(modalElem);
			document.body.appendChild(applicationModal);
		} else {
			let iElem = document.querySelector("#" + id + " .sparxpres-dynamic-iframe");
			if (iElem && iElem.src) {
				iElem.src = applicationSrc;
			}
			// show modal
			applicationModal.classList.remove("sparxpres-d-none");
		}
	}

	/**
	 *
	 * @param id
	 * @return {HTMLDivElement}
	 * @private
	 */
	static _buildRootElement(id) {
		const rootElem = document.createElement("div");
		rootElem.id = id;
		rootElem.className = "sparxpres-modal";
		rootElem.setAttribute("role", "dialog");
		rootElem.setAttribute("tabindex", "-1");
		rootElem.setAttribute("aria-modal", "true");

		//make sure sparxpres-d-none class always exist for the modal
		const styleElem = document.createElement("style");
		styleElem.innerHTML = ".sparxpres-d-none {display: none;}";
		rootElem.appendChild(styleElem);

		return rootElem;
	}

	/**
	 *
	 * @param id
	 * @param content
	 * @return {HTMLDivElement}
	 * @private
	 */
	static _buildModalContentElement(id = '', content = {}) {
		const modalElem = document.createElement("div");
		modalElem.classList.add("sparxpres-modal-content");

		const modalCloseElem = document.createElement("span");
		modalCloseElem.classList.add("sparxpres-modal-close");
		modalCloseElem.addEventListener("click", function () {
			document.getElementById(id).classList.add("sparxpres-d-none");
		});
		modalCloseElem.innerHTML = "&times;"
		// append to modalElem
		modalElem.appendChild(modalCloseElem);

		const contentElem = document.createElement("div");
		contentElem.classList.add("sparxpres-dynamic-content");
		contentElem.innerHTML = content.html;
		// append to modalElem
		modalElem.appendChild(contentElem);

		if (content.style) {
			const styleElem = document.createElement("style");
			styleElem.innerHTML = content.style;
			modalElem.appendChild(styleElem);
		}

		return modalElem;
	}

}